export enum AccountStatusEnum {
  NOT_SUBMITTED = "NOT SUBMITTED",
  SUBMITTED = "SUBMITTED",
  PENDING_ACTIVATION = "PENDING ACTIVATION",
  ACTIVATED = "ACTIVATED",
  PAYMENT_DETAILS_RECEIVED = "PAYMENT DETAILS RECEIVED",
  REGISTERED_CARRIER_ACCOUNT = "REGISTERED CARRIER ACCOUNT",
}
